export class User {

    constructor(
      public UserID: string,
      public Password: string
    ) {  }
  
  }